export const YA_OPTIONS = ["2021", "2022", "2023", "2024", "2025", "2026"];

export const fmtRM = (n) =>
  "RM " +
  Number(n || 0).toLocaleString("en-MY", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

// RM with no decimal places
export const fmtRM0 = (n) =>
  "RM " +
  Number(n || 0).toLocaleString("en-MY", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

// plain number with thousands separators, no RM (for report tables)
export const fmtNum = (n) => {
  const v = Number(n || 0);
  const s = Math.abs(v).toLocaleString("en-MY", { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  return v < 0 ? `(${s})` : s;
};

export const defaultOtherIncome = () => [{ label: "Other income", amount: 0 }];

export const defaultDisallowables = () => [
  { noteNo: 1, description: "Incorporation fee", remark: "Add back; claim special deduction (S.111)", amount: 0, disallowed: 0, treatment: "disallowed", specialCategory: "S111" },
  { noteNo: 2, description: "Audit fee", remark: "Add back; claim special deduction (S.132)", amount: 0, disallowed: 0, treatment: "disallowed", specialCategory: "S132" },
  { noteNo: 3, description: "Secretary fee", remark: "Add back; claim special deduction (S.157)", amount: 0, disallowed: 0, treatment: "disallowed", specialCategory: "S157SEC" },
  { noteNo: 4, description: "Tax fee", remark: "Add back; claim special deduction (S.157)", amount: 0, disallowed: 0, treatment: "disallowed", specialCategory: "S157TAX" },
  { noteNo: 5, description: "Depreciation of PPE", remark: "Add back; claim capital allowance", amount: 0, disallowed: 0, treatment: "disallowed" },
  { noteNo: 6, description: "Entertainment", remark: "Add back 50% (S.39(1)(l))", amount: 0, disallowed: 0, treatment: "disallowed" },
];

// Special-deduction categories a disallowed expense can be linked to
export const SPECIAL_CATEGORIES = [
  { key: "S111", label: "S.111 Incorporation Fee", code: "S.111", sdLabel: "S.111 Deduction of incorporation fee" },
  { key: "S132", label: "S.132 Audit Fee", code: "S.132", sdLabel: "S.132 Deduction of audit fee" },
  { key: "S157SEC", label: "S.157 Secretary Fee", code: "S.157", sdLabel: "S.157 Deduction of secretary fee" },
  { key: "S157TAX", label: "S.157 Tax Fee", code: "S.157", sdLabel: "S.157 Deduction of tax fee" },
];

export const defaultSpecialDeductions = () => [
  { label: "S.111 Deduction of incorporation fee", amount: 0, category: "S111" },
  { label: "S.132 Deduction of audit fee", amount: 0, category: "S132" },
  { label: "S.157 Deduction of secretary fee", amount: 0, category: "S157SEC" },
  { label: "S.157 Deduction of tax fee", amount: 0, category: "S157TAX" },
];

export const defaultAssets = () => [
  {
    description: "", category: "", yearAcq: "", rateIA: 20, rateAA: 20,
    originalCost: 0, costBf: 0, addition: 0, deletion: 0, disposalValue: 0, inUse: true, notional: false, rvBf: 0,
  },
];

// Standard capital-allowance asset categories (suggestions; category stays free-text).
// rateIA / rateAA are the usual LHDN rates and are auto-filled when a known category is picked.
export const CA_CATEGORIES = [
  { label: "MV-MOTOR VEHICLE", rateIA: 20, rateAA: 20 },
  { label: "PM-PLANT & MACHINERY", rateIA: 20, rateAA: 14 },
  { label: "HM-HEAVY MACHINERY", rateIA: 20, rateAA: 20 },
  { label: "OE-OFFICE EQUIPMENT", rateIA: 20, rateAA: 10 },
  { label: "FF-FURNITURE & FITTINGS", rateIA: 20, rateAA: 10 },
  { label: "CP-COMPUTER & IT EQUIPMENT", rateIA: 20, rateAA: 20 },
  { label: "EE-ELECTRICAL EQUIPMENT", rateIA: 20, rateAA: 10 },
  { label: "AC-AIR CONDITIONER", rateIA: 20, rateAA: 10 },
  { label: "SB-SIGNBOARD", rateIA: 20, rateAA: 10 },
  { label: "RN-RENOVATION", rateIA: 20, rateAA: 10 },
  { label: "TE-TOOLS & EQUIPMENT", rateIA: 20, rateAA: 14 },
  { label: "MT-MACHINERY & TOOLS", rateIA: 20, rateAA: 14 },
  { label: "SV-SURVEILLANCE EQUIPMENT", rateIA: 20, rateAA: 10 },
  { label: "TL-TELECOMMUNICATION EQUIPMENT", rateIA: 20, rateAA: 10 },
  { label: "IB-INDUSTRIAL BUILDING", rateIA: 10, rateAA: 3 },
  { label: "SV-SMALL VALUE ASSET", rateIA: 0, rateAA: 100 },
];
